export const DIALOG_MARGIN_TOP = "40px";
export const DIALOG_MAX_WIDTH = "1200px";
export const DIALOG_WIDTH = "90%";
export const DIALOG_MAX_HEIGHT = "90vh";

export const GRID_SPACING = 4;
export const SECTION_MARGIN_TOP = 4;
export const FORM_PADDING = 3;

export const FONT_SIZES = {
  INPUT: "1.05rem",
  LABEL: "1.05rem",
  HEADING: "1.35rem",
  BODY: "1.02rem",
} as const;

export const GRID_SIZES = {
  LEFT_PANEL: { xs: 12, lg: 8 },
  RIGHT_PANEL: { xs: 12, lg: 4 },
  STORAGE: { xs: 12, lg: 7 },
  PRICING: { xs: 12, lg: 5 },
  FULL: { xs: 12 },
} as const;
